/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Row_Consistent_ForInputs */

const en_us2_profile_row_consistent_for = /** @type {(inputs: Profile_Row_Consistent_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How long you've trained`)
};

const pt_br2_profile_row_consistent_for = /** @type {(inputs: Profile_Row_Consistent_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Há quanto tempo treina`)
};

const es_419_profile_row_consistent_for = /** @type {(inputs: Profile_Row_Consistent_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hace cuánto entrenas`)
};

const pt_pt2_profile_row_consistent_for = /** @type {(inputs: Profile_Row_Consistent_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Há quanto tempo treinas`)
};

const fr_fr2_profile_row_consistent_for = /** @type {(inputs: Profile_Row_Consistent_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Depuis quand tu t'entraînes`)
};

const de_de2_profile_row_consistent_for = /** @type {(inputs: Profile_Row_Consistent_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie lange du trainierst`)
};

const it_it2_profile_row_consistent_for = /** @type {(inputs: Profile_Row_Consistent_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Da quanto ti alleni`)
};

/**
* | output |
* | --- |
* | "How long you've trained" |
*
* @param {Profile_Row_Consistent_ForInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_row_consistent_for = /** @type {((inputs?: Profile_Row_Consistent_ForInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Row_Consistent_ForInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_row_consistent_for(inputs)
	if (locale === "es-419") return es_419_profile_row_consistent_for(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_row_consistent_for(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_row_consistent_for(inputs)
	if (locale === "de-DE") return de_de2_profile_row_consistent_for(inputs)
	if (locale === "it-IT") return it_it2_profile_row_consistent_for(inputs)
	return en_us2_profile_row_consistent_for(inputs)
});
export { profile_row_consistent_for as "profile.row_consistent_for" }